/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Check_Continue_AnywayInputs */

const en_directory_submit_check_continue_anyway = /** @type {(inputs: Directory_Submit_Check_Continue_AnywayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue anyway`)
};

const zh_directory_submit_check_continue_anyway = /** @type {(inputs: Directory_Submit_Check_Continue_AnywayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仍要继续`)
};

/**
* | output |
* | --- |
* | "Continue anyway" |
*
* @param {Directory_Submit_Check_Continue_AnywayInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_check_continue_anyway = /** @type {((inputs?: Directory_Submit_Check_Continue_AnywayInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Check_Continue_AnywayInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_check_continue_anyway(inputs)
	return zh_directory_submit_check_continue_anyway(inputs)
});
export { directory_submit_check_continue_anyway as "directory.submit.check.continue_anyway" }